// removed by extract-text-webpack-plugin
module.exports = {"ObservationBadge--bg-no-observations":"ObservationBadge--bg-no-observations","observationBadgeBgNoObservations":"ObservationBadge--bg-no-observations"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModerationCard/ObservationBadges.scss
// module id = 520
// module chunks = 0